<template>
  <g-master name="forms3"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            modalWidth="80%"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <g-lookup :label="$t('Aprobador Cesantias1')"
                    :formItemConfig="fiOptions"
                    endpoint="personas"
                    :decorator="['id_emp_approv1', { rules: [{ required: true}] }]"
          >
          </g-lookup>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown :label="$t('Rol Aprobador Cesantias1')"
                      :formItemConfig="fiOptions"
                      endpoint="hierarchy_lookup"
                      :decorator="['role_name', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                      :params="roles_request">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <g-lookup :label="$t('AprobadorCesantias2')"
                    :formItemConfig="fiOptions"
                    endpoint="personas"
                    :decorator="['id_emp_approv2', { rules: [{ required: true, message: 'Valor requerido'}] }]"
          >
          </g-lookup>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown :label="$t('Rol Aprobador Cesantias2')"
                      :formItemConfig="fiOptions"
                      endpoint="hierarchy_lookup"
                      :decorator="['role_name2', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                      :params="roles_request">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions" v-if="$getConfigValue('MOSTRAR_CAMPO_APROBADOR_CESANTIAS3', 'NO') === 'SI'">
          <g-lookup :label="$t('AprobadorCesantias3')"
                    :formItemConfig="fiOptions"
                    endpoint="personas"
                    :decorator="['id_emp_approv3', { rules: [{ required: false}] }]"
          >
          </g-lookup>
        </a-col>
        <a-col v-bind="colOptions" v-if="$getConfigValue('MOSTRAR_CAMPO_APROBADOR_CESANTIAS3', 'NO') === 'SI'">
          <g-dropdown :label="$t('Rol Aprobador Cesantias3')"
                      :formItemConfig="fiOptions"
                      endpoint="hierarchy_lookup"
                      :decorator="['role_name3', { rules: [{ required: false}] }]"
                      :params="roles_request">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown :label="$t('Oficina')"
                      :formItemConfig="fiOptions"
                      endpoint="offices"
                      :decorator="['office_id', { rules: [{ required: true, message: 'Valor requerido'}] }]">
          </g-dropdown>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>

<script>
  export default {
    data () {
      let ocultarAprobador3 = this.$getConfigValue('DASHBOARD_SOL_OCULTA_APROB3_CESANTIAS', 'SI') === 'SI'
      return {
        roles_request: {h_lookup_type: 'ROLES_CESANTIAS', use_description: true},
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'cespar_loc_approv',
          tableSetup: {
            tableConfig: {
              pagination: {
                pageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              },
              rowKey: 'loc_approv_id'
            },
            columns: [
              {title: 'Aprobador1', dataIndex: 'id_emp_approv1', sorter: true},
              {title: 'Nombre Aprobador1', dataIndex: 'nombre_emp_approv1', sorter: true},
              {title: 'Rol Aprobador1', dataIndex: 'role_name', sorter: true},
              {title: 'Aprobador2', dataIndex: 'id_emp_approv2', sorter: true},
              {title: 'Nombre Aprobador2', dataIndex: 'nombre_emp_approv2', sorter: true},
              {title: 'Rol Aprobador2', dataIndex: 'role_name2', sorter: true},
              ...(ocultarAprobador3 ? {title: 'Aprobador3', dataIndex: 'id_emp_approv3', sorter: true} : []),
              ...(ocultarAprobador3 ? {title: 'Nombre Aprobador3', dataIndex: 'nombre_emp_approv3', sorter: true} : []),
              ...(ocultarAprobador3 ? {title: 'Rol Aprobador3', dataIndex: 'role_name3', sorter: true} : []),
              {title: this.$t('Oficina'), dataIndex: 'office_name', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_emp_approv1'},
            {name: 'id_emp_approv2'},
            {name: 'id_emp_approv3'},
            {name: 'role_name'},
            {name: 'role_name2'},
            {name: 'role_name3'},
            {name: 'office_id'}
          ]
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/WfRequest/CesparLocApprov.vue